import { ChevronRightIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import DeleteReportTemplateDialog from "features/Profile/ReportTemplates/DeleteReportTemplateDialog";

import { ROUTES } from "utils/constants";

export default function ReportTemplateCard({ reportTemplate }: { reportTemplate: any }) {
  const naviagate = useNavigate();
  const { name, description, id } = reportTemplate;

  const navigateToTemplate = () => naviagate(ROUTES.PROFILE_REPORT_TEMPLATE.replace(":id", id?.toString() ?? ""));

  return (
    <div
      className="p-4 border border-general-gray-400 rounded flex justify-between items-center cursor-pointer"
      onClick={navigateToTemplate}
    >
      <div className="flex flex-col gap-1.5">
        <div className="font-semibold">{name}</div>
        <div className="flex gap-6 text-sm text-general-gray-700">
          <div>{description}</div>
        </div>
      </div>
      <div className="flex gap-4 items-center" onClick={(e) => e.stopPropagation()}>
        <DeleteReportTemplateDialog id={id} />
        <ChevronRightIcon className="size-6 min-w-fit" onClick={navigateToTemplate} />
      </div>
    </div>
  );
}
